import _ from "lodash";
import { getAppInsights } from './appInsights';
//declare var angular: ng.IAngularStatic;
((function () {
    "use strict";
    var app = angular.module("skillBuilderSaaS", ["angular-cron-jobs", "angularMoment", "angular-intro", "checklist-model", "common.services", "common.translate", "datatables", "datatables.bootstrap", "datatables.buttons",
        "datatables.options", "dropzone", "ngAnimate", "ngCookies", "ngFileUpload", "ngJcrop", "ngMeta", "ngSanitize", "ngStorage", "ngTouch", "ng-slide-down", "pascalprecht.translate", "pageslide-directive",
        "n3-pie-chart", "oc.lazyLoad", "pretty-checkable", "sb.angular-ellipsis", "sb.cgNotify", "switcher", "timer", "tmh.dynamicLocale", "ui.bootstrap", "ui.bootstrap.pagination", "ui.router", "ui.select", "ui.slimscroll",
        "ui.sortable", "ui.validate", "ui.mask", "integralui", "frapontillo.bootstrap-switch", "ngSpectrum", "wt.responsive", "fiestah.money", "xeditable", "ngclipboard", "720kb.socialshare", "isoCurrency"
    ]);
    //#region CONSTANTS
    //app.constant("AUTH_EVENTS", {
    //	loginSuccess: "auth-login-success",
    //	loginFailed: "auth-login-failed",
    //	logoutSuccess: "auth-logout-success",
    //	sessionTimeout: "auth-session-timeout",
    //	notAuthenticated: "auth-not-authenticated",
    //	notAuthorized: "auth-not-authorized"
    //});
    var userRoles = {
        all: "*",
        superAdmin: "Super Admin",
        siteAdmin: "Site Admin",
        groupAdmin: "Group Admin",
        organizationAdmin: "Organization Admin",
        reporter: "Reporter",
        learningItemAdmin: "Learning Item Admin",
        forumModerator: "Forum Moderator",
        facilitator: "Facilitator",
        evaluator: "Evaluator",
        workHistoryEvaluator: "Work History Evaluator",
        practicalEvaluator: "Practical Evaluator",
        performanceEvaluator: "Performance Evaluator",
        certificationMonitor: "Certification Monitor",
        examProctor: "Exam Proctor",
        learner: "Learner"
    };
    app.constant("USER_ROLES", userRoles);
    app.constant("CONST_ALLROLES", [
        { name: userRoles.learner, order: 1 },
        { name: userRoles.examProctor, order: 2 },
        { name: userRoles.certificationMonitor, order: 3 },
        { name: userRoles.evaluator, order: 4 },
        { name: userRoles.performanceEvaluator, order: 5 },
        { name: userRoles.practicalEvaluator, order: 6 },
        { name: userRoles.workHistoryEvaluator, order: 7 },
        { name: userRoles.facilitator, order: 8 },
        { name: userRoles.learningItemAdmin, order: 9 },
        { name: userRoles.forumModerator, order: 10 },
        { name: userRoles.reporter, order: 11 },
        { name: userRoles.organizationAdmin, order: 12 },
        { name: userRoles.groupAdmin, order: 13 },
        { name: userRoles.siteAdmin, order: 14 },
        { name: userRoles.superAdmin, order: 15 }
    ]);
    app.constant("REG_EXP", {
        email: /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,24}\b$/i,
        username: /^\S*$/,
        password: /^(?=.*[a-z])(?=.*[A-Z]).+$/,
        specialCharacterPassword: /^[^&+%*:.<>\\/?]+$/,
        commonSpecialCharacterExclude: /^[^&+%*:.<>\\/?]+$/,
        harmfulCheck: /[&+%*:.<>?]/,
        phone: /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
        friendlyUrl: /^[a-zA-Z0-9-]+(\/[a-zA-Z0-9-]+)*$/,
        pageName: /^[a-zA-Z0-9- ]+$/
    });
    app.constant("DEFAULT_VALUES", {
        timeBeforeSessionExpires: 60000
    });
    app.constant("SELFREGISTRATION_SETTINGS", {
        off: 0,
        optional: 1,
        required: 2
    });
    app.constant("SCOREEXAM_STATUS", {
        unmarked: 3
    });
    app.constant("EXAMDETAIL_STATUS", {
        Disabled: 0,
        Enabled: 1
    });
    app.constant("FILE_FORMATS", {
        image: ".jpg,.jpeg,.png,.gif",
        assignment: "image/*,audio/*,video/*,.pdf,.doc,.docx,.txt,.xls,.xlsx,.xlsm,.ppt,.pptx",
        workHistory: "image/*,.pdf,.doc,.docx,.txt,.xls,.xlsx,.xlsm"
    });
    // allow DI for use in controllers, unit tests
    app.constant('_', _)
        // use in views, ng-repeat="x in _.range(3)"
        .run(["$rootScope", function ($rootScope) {
            $rootScope._ = _;
        }]);
    //#endregion CONSTANTS
    //#region CONFIG
    /* Config */
    app.config(["$provide", function ($provide) {
            $provide.decorator("$exceptionHandler", ["$delegate", function ($delegate) {
                    return function (exception, cause) {
                        //exception.message = "Please contact the Help Desk! \nMessage: " + exception.message; //TODO - PBI - Localize this message
                        $delegate(exception, cause);
                        console.log("An unexpected error has occurred: " + exception.message);
                    };
                }]);
        }]);
    app.config(["tmhDynamicLocaleProvider", function (tmhDynamicLocaleProvider) {
            tmhDynamicLocaleProvider.localeLocationPattern("/Scripts/i18n/angular-locale_{{locale}}.js");
        }]);
    app.config(["$ocLazyLoadProvider", function ($ocLazyLoadProvider) {
            $ocLazyLoadProvider.config({
                modules: [
                    { name: "TinyMCE", files: ["/Scripts/tinymce.4.4.2/tinymce.min.js", "/Scripts/ui-tinymce/tinymce.min.js"] },
                    { name: "Gamification", files: ["Scripts/angular.audio.min.js", "Scripts/angular-ui-notification.min.js", { type: "css", path: "Content/angular-ui-notification.min.css" }] }
                ]
            });
        }]);
    app.config(["$stateProvider", "$urlRouterProvider", "$urlMatcherFactoryProvider", "$locationProvider", "USER_ROLES", "ngMetaProvider", function ($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $locationProvider, USER_ROLES, ngMetaProvider) {
            ngMetaProvider.setDefaultTitle("SkillBuilder LMS");
            ngMetaProvider.setDefaultTag("description", "");
            $urlMatcherFactoryProvider.strictMode(false);
            //$urlRouterProvider.otherwise("main.notFound");
            $urlRouterProvider.otherwise(function ($injector) {
                var $state = $injector.get("$state");
                var $location = $injector.get("$location");
                var match = $location.$$url.match("/en-CA|/fr-CA|/pt-BR|/es-ES");
                if (match) {
                    var lang = match[0].substring(1);
                    $state.go("main.home", { lang: lang }, { location: false });
                }
                else {
                    $state.go("main.notFound", {}, { location: false });
                    //if ($location.$$url === "/tenantNotFound.html" || $location.$$url === "/maintenance.html") {
                    //	window.location.reload();
                    //}
                    //else
                    //	$state.go("main.notFound", {}, { location: false });
                }
            });
            //$urlRouterProvider.otherwise(function (injector, $location) {
            //	var url = $location.path().split("/");
            //	url.splice(-1, 1);
            //	url = url.join("/");
            //	//if (url === "")
            //	//	url = "/sign-in";
            //	$location.url(url);
            //});
            $urlRouterProvider.rule(function (_injector, $location) {
                var path = $location.path();
                var hasTrailingSlash = path[path.length - 1] === "/";
                if (hasTrailingSlash) {
                    //if last character is a slash, return the same url without the slash
                    var newPath = path.substr(0, path.length - 1);
                    return newPath;
                }
                //TODO - PBI - Figure out how to make this work properly
                /*else {
                    var normalized = path.toLowerCase();
                    if (path !== normalized)
                        return normalized;
                }*/
                return false;
            });
            // doesn't seem to work
            //if (environment.production) {
            //	console.log("THIS IS PROD MODE")
            //} else {
            //	console.log("THIS IS DEV MODE")
            //}
            $stateProvider
                .state("main", {
                url: "/{lang:(?:en-CA|fr-CA|pt-BR|es-ES)}",
                params: { lang: { squash: true, value: null } },
                abstract: true,
                resolve: {
                    tenant: ["frameworkService", "$q", "$rootScope", "$translate", function (frameworkService, $q, $rootScope, $translate) {
                            var deferred = $q.defer();
                            frameworkService.init(function (tenantData) {
                                $rootScope.showPageLoader = false;
                                $translate.onReady(function () {
                                    deferred.resolve(tenantData);
                                });
                                if (tenantData.title)
                                    ngMetaProvider.setDefaultTitle(tenantData.title);
                                if (tenantData.description)
                                    ngMetaProvider.setDefaultTag("description", tenantData.description);
                            });
                            return deferred.promise;
                        }]
                },
                views: {
                    "": {
                        template: "<main-section></main-section>"
                    },
                    "navBar": {
                        template: "<navbar></navbar>"
                    }
                }
            })
                .state("main.customPage", {
                url: "/pages/{friendlyUrl:.*}",
                component: "",
                data: {
                    showFooter: "not-auth",
                    urlAuthCheck: true
                }
            })
                .state("main.helpArticles", {
                url: "/articles",
                data: {
                    showFooter: "not-auth"
                }
            })
                .state("main.helpArticlesTypeView", {
                url: "/articles/{type}/{id}",
                data: {
                    showFooter: "not-auth"
                }
            })
                .state("main.helpArticlesView", {
                url: "/articles/{id}",
                data: {
                    showFooter: "not-auth"
                }
            })
                //.state("tenantNotFound", {
                //	url: "/tenantNotFound.html",
                //})
                //PUBLIC PAGES
                //.state("main.homePage", {
                //	url: "/",
                //	template: "<home-page></home-page>",
                //	data: {
                //		showFooter: true
                //	}
                //})
                //EXAMPLE ocLazyLoad webpack
                .state("main.certificationCheck", {
                url: "/certification-check",
                //component: "certificationCheck",
                data: {
                    showFooter: "not-auth"
                },
                //	lazyLoad: function ($transition$) {
                //		var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //		return import(
                //			/* webpackChunkName: "certificationCheck" */
                //			"./public/certificationCheck.component"
                //		).then(mod => $ocLazyLoad.load(mod.CERTIFICATION_CHECK_MODULE));
                //	}
            })
                .state("main.certificationCheckOrganizationExports", {
                url: "/organization-certification-exports",
                //component: "organizationCertificationExports",
                data: {
                    showFooter: false,
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.certificationMonitor]
                } //,
                //lazyLoad: function ($transition$) {
                //	var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //	return import(
                //		/* webpackChunkName: "organizationCertificationExports" */
                //		"./public/organizationCertificationExports.component"
                //	).then(mod => $ocLazyLoad.load(mod.organizationCertificationExports));
                //}
            })
                .state("main.privacy", {
                url: "/privacy",
                component: "privacy",
                data: {
                    showFooter: true
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "privacy" */
                    "./public/privacy.component").then(function (mod) { return $ocLazyLoad.load(mod.privacy); });
                }
            })
                .state("main.passwordReset", {
                url: "/password-reset/{token}",
                template: "<password-reset></password-reset>",
                data: {
                    showFooter: true
                }
            })
                .state("main.requestPasswordReset", {
                url: "/request-password-reset",
                template: "",
                data: {
                    showFooter: true
                }
            })
                .state("main.forgotUsername", {
                url: "/forgot-username",
                template: "",
                data: {
                    showFooter: true
                }
            })
                .state("main.signOut", {
                url: "/sign-out",
                component: "signIn",
                data: {
                    showFooter: true
                }
            })
                .state("main.selfRegistration", {
                url: "/sign-up?code&organization",
                component: "selfRegistration",
                params: {
                    code: { squash: true, value: null },
                    organization: { squash: true, value: null }
                },
                data: {
                    meta: {
                        "title": "Create Account"
                    },
                    showFooter: true
                },
                resolve: {
                    auth: ["authService", "homePageService", "$timeout", "$q", function (authService, homePageService, $timeout, $q) {
                            var deferred = $q.defer();
                            if (!authService.authentication.isAuth) {
                                deferred.resolve();
                            }
                            else {
                                deferred.reject();
                                $timeout(function () {
                                    homePageService.loadSignedInHomePage();
                                });
                            }
                            return deferred.promise;
                        }]
                }
            })
                .state("main.preregistration", {
                url: "/request-access",
                template: "<preregistration></preregistration>",
                data: {
                    showFooter: true
                }
            })
                .state("main.verifyEmail", {
                url: "/verify-email/{token}",
                template: "<verify-email></verify-email>",
                data: {
                    showFooter: true
                }
            })
                .state("main.examAttemptRequestApproval", {
                url: "/exam-attempt-request?t&a&u",
                template: "<exam-attempt-request-approval></exam-attempt-request-approval>",
                data: {
                    showFooter: true
                }
            })
                .state("main.notificationUnsubscribe", {
                url: "/unsubscribe/{template:int}?u",
                template: "<notification-unsubscribe></notification-unsubscribe>",
                data: {
                    showFooter: true
                }
            })
                .state("main.orderDetails", {
                url: "/view-order/{id}",
                template: "",
                data: {
                    hideAdminMenu: true
                }
            })
                .state("main.signIn", {
                url: "/sign-in",
                component: "signIn",
                params: {
                    superAdminSignIn: false
                },
                data: {
                    showFooter: true
                },
                //resolve: {
                //	auth: ["authService", "homePageService", "$timeout", "$q", (authService, homePageService, $timeout, $q) => {
                //		var deferred = $q.defer();
                //		if (!authService.authentication.isAuth) {
                //			deferred.resolve();
                //		} else {
                //			deferred.reject();
                //			$timeout(() => {
                //				homePageService.loadSignedInHomePage();
                //			});
                //		}
                //		return deferred.promise;
                //	}]
                //}
            })
                .state("main.signInSuperAdmin", {
                url: "/sign-in-sa",
                component: "signIn",
                params: {
                    superAdminSignIn: true
                },
                data: {
                    showFooter: true
                }
            })
                .state("main.signIn.signedInInADifferentBrowser", {
                url: "/different-browser",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openStateModal("app/modals/signIn/signedInDifferentBrowserModalView.html");
                    }]
            })
                .state("main.accessDenied", {
                url: "/access-denied",
                template: "<access-denied></access-denied>"
            })
                .state("main.notFound", {
                url: "/not-found",
                template: "<not-found></not-found>",
                data: {
                    showFooter: true
                }
            })
                .state("main.badgeCriteria", {
                url: "/openBadges/badgeCriteria/{badgeGuid}/{localizationId}",
                template: "<badge-criteria></badge-criteria>"
            })
                //Dashboards
                .state("main.dashboard", {
                url: "/dashboard",
                template: "",
                //authenticate: true,
                params: {
                    personSeq: null,
                    isReadOnly: false
                },
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.dashboardGroupAdminCompleted", {
                url: "/dashboard/completed",
                component: "groupAdminCompleted",
                //authenticate: true,
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "groupAdminCompleted" */
                    "./dashboard/groupAdmin/groupAdminCompleted.component").then(function (mod) { return $ocLazyLoad.load(mod.groupAdminCompleted); });
                }
            })
                .state("main.dashboardGroupAdminExpiring", {
                url: "/dashboard/expiring",
                component: "groupAdminExpiring",
                //authenticate: true,
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "groupAdminExpiring" */
                    "./dashboard/groupAdmin/groupAdminExpiring.component").then(function (mod) { return $ocLazyLoad.load(mod.groupAdminExpiring); });
                }
            })
                .state("main.dashboardAdminRecentUsers", {
                url: "/dashboard/recent-users",
                component: "dashboardAdminRecentUsers",
                //				authenticate: true,
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "dashboardAdminRecentUsers" */
                    "./dashboard/admin/dashboardAdminRecentUsers.component").then(function (mod) { return $ocLazyLoad.load(mod.dashboardAdminRecentUsers); });
                }
            })
                .state("main.forums", {
                url: "/forums/topics",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.forumsList", {
                url: "/forums",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.forumsNew", {
                url: "/forums/new",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.forumsEdit", {
                url: "/forums/:slug",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.forumsTopics", {
                url: "/forums/:slug/topics",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.forumsTopic", {
                url: "/forums/:forumSlug/topics/:topicSlug/:id",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.forumsAdmin.moderateTopics", {
                url: "/forums-admin/moderate-topics",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.forumModerator]
                }
            })
                .state("main.forumsAdmin.moderatePosts", {
                url: "/forums-admin/moderate-posts",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.forumModerator]
                }
            })
                .state("main.home", {
                url: "/",
                template: "",
                params: { lang: null },
                data: {
                    showFooter: true
                }
            })
                //.state("main.home", {
                //	url: "/",
                //	component: "home",
                //	params: { lang: null }
                //})
                //.state("main.homeWithLang", {
                //    url: "/{lang:(?:en-CA|fr-CA|pt-BR|es-ES)}",
                //    //template: "<div ui-view></div>",
                //    controller: ["homePageService", "$timeout", function (homePageService, $timeout) {
                //        $timeout(() => {
                //            homePageService.loadHomePage();
                //        });
                //    }]
                //})
                //Abstract for the Parent Menus
                .state("main.people", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
            })
                .state("main.assignments", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
            })
                .state("main.evaluations", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
                resolve: {
                    //this is causing an issue with /evaluations/exam-sessions when loading for 1st time
                    //the page redirects back to the previous url
                    loadTinyMCE: ["$ocLazyLoad", function ($ocLazyLoad) {
                            return $ocLazyLoad.load("TinyMCE");
                        }]
                }
            })
                .state("main.learningItems", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
                resolve: {
                    loadTinyMCE: ["$ocLazyLoad", function ($ocLazyLoad) {
                            return $ocLazyLoad.load("TinyMCE");
                        }]
                }
            })
                .state("main.dataExport", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
            })
                .state("main.reporting", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
            })
                .state("main.storefront", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
            })
                .state("main.catalog", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
                //	resolve: {
                //		loadTinyMCE: ["$ocLazyLoad", ($ocLazyLoad) => {
                //			return $ocLazyLoad.load("TinyMCE");
                //		}]
                //	}
            })
                .state("main.forumsAdmin", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
            })
                .state("main.gamification", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
            })
                .state("main.settings", {
                abstract: true,
                template: "<div class='m-b-80' ui-view></div>",
                resolve: {
                    loadTinyMCE: ["$ocLazyLoad", function ($ocLazyLoad) {
                            return $ocLazyLoad.load("TinyMCE");
                        }]
                }
            })
                //---------------
                //Not tied to an Admin Menu
                //---------------
                //account
                .state("main.myAccount", {
                url: "/account",
                template: "<my-account></my-account>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountMissingRequiredRegistrationFields", {
                url: "/account/missing-required-registration-fields",
                template: "<missing-required-registration-fields></missing-required-registration-fields>",
                params: {
                    stateName: null,
                    stateParameters: null
                },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountConnectExternalLogin", {
                url: "/account/connect-external-login?loginProvider&providerKey",
                component: "connectExternalLogin",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountInventory", {
                url: "/inventory",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountInventoryDetails", {
                url: "/inventory/:id",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                //.state("main.accountInventoryDetails.assign", {
                //	authenticate: true,
                //	params: {
                //		productId: null,
                //		assignToOrganization: null,
                //		available: null
                //	},
                //	onEnter: ["stateModalService", (stateModalService) => {
                //		stateModalService.openStateModal("app/inventory/inventoryAssignModalView.html", "InventoryAssignModalCtrl as vm");
                //	}],
                //	data: {
                //		authorizedRoles: [USER_ROLES.all]
                //	}
                //})
                //.state("main.accountInventoryDetails.transfer", {
                //	authenticate: true,
                //	params: {
                //		productId: null,
                //		available: null
                //	},
                //	onEnter: ["stateModalService", (stateModalService) => {
                //		stateModalService.openComponent("inventoryTransferModal");
                //	}],
                //	data: {
                //		authorizedRoles: [USER_ROLES.all]
                //	},
                //	lazyLoad: function ($transition$) {
                //		var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //		return import(
                //			/* webpackChunkName: "inventoryTransferModal" */
                //			"./inventory/inventoryTransferModal.component"
                //		).then(mod => $ocLazyLoad.load(mod.inventoryTransferModal));
                //	}
                //})
                //Account Notifications
                //https://ui-router.github.io/guide/lazyloading
                .state("main.accountNotifications", {
                url: "/account/notifications",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountNotificationsDetail", {
                url: "/account/notifications/:id",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountNotificationSettings", {
                url: "/account/notifications/settings",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountPoints", {
                url: "/account/points",
                template: "<my-points></my-points>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountTier", {
                url: "/account/tier",
                template: "<my-tier></my-tier>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountBadges", {
                url: "/account/badges",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                //.state("main.accountBadges.badges", {
                //	template: "<badges></badges>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.all]
                //	}
                //})
                //.state("main.accountBadges.upload", {
                //	url: "/upload",
                //	template: "",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.all]
                //	}
                //})
                //.state("main.accountBadges.badgeDetails", {
                //	url: "/details",
                //	template: "",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.all]
                //	},
                //	params: {
                //		badgeGuid: null
                //	}
                //})
                .state("main.accountBadgesDetails", {
                url: "/account/badges/:badgeGuid",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountCertificates", {
                url: "/account/certificates",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountRedeemCode", {
                url: "/account/redeem-code",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountRedeemCode.code", {
                url: "/{code}",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                //ShoppingCart
                .state("main.shoppingCart", {
                url: "/shopping-cart",
                template: "",
                data: {
                    meta: {
                        "title": "Shopping Cart"
                    },
                    showFooter: true
                }
            })
                .state("main.storefrontCatalog", {
                url: "/catalog",
                //component: "catalog",
                template: "",
                data: {
                    meta: {
                        "title": "Catalog"
                    },
                    showFooter: true
                }
            })
                .state("main.catalogCategory", {
                url: "/catalog/c/:category",
                template: "",
                data: {
                    showFooter: true
                }
            })
                .state("main.catalogCategoryProductItem", {
                url: "/catalog/c/:category/:slug",
                template: "",
                data: {
                    showFooter: true
                }
            })
                .state("main.advancedCatalogSearch", {
                url: "/catalog/search?q&c",
                data: {
                    meta: {
                        "title": "Search"
                    },
                    showFooter: true
                }
            })
                //.state("main.advancedCatalogProductItem", {
                //	url: "/catalog/products/{slug}",
                //	template: "",
                //	data: {
                //		showFooter: true
                //	}
                //})
                .state("main.advancedCatalogProducts", {
                url: "/catalog/products",
                data: {
                    meta: {
                        "title": "Products"
                    },
                    showFooter: true
                }
            })
                .state("main.advancedCatalogExclusiveProducts", {
                url: "/catalog/exclusive-products",
                data: {
                    meta: {
                        "title": "Exclusive Products"
                    },
                    showFooter: true
                }
            })
                .state("main.advancedCatalogExclusiveProductsItem", {
                url: "/catalog/exclusive-products/{slug}",
                data: {
                    meta: {
                        "title": "Exclusive Products"
                    },
                    showFooter: true
                }
            })
                .state("main.storefrontCatalogItem", {
                url: "/catalog/{slug}",
                //component: "catalogItem",
                template: "",
                data: {
                    meta: {
                        "title": "Catalog"
                    },
                    showFooter: true
                }
            })
                .state("main.catalog.products", {
                url: "/products",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.catalog.productsItem", {
                url: "/products/{slug}",
                //component: "product",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                //.state("main.storefront.product.information", {
                //	url: "/info",
                //	component: "productInformation",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	},
                //	resolve: {
                //		loadTinyMCE: ["$ocLazyLoad", ($ocLazyLoad) => {
                //			return $ocLazyLoad.load("TinyMCE");
                //		}]
                //	}
                //})
                //.state("main.storefront.product.pricing", {
                //	url: "/pricing",
                //	component: "productPricing",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.storefront.product.crossSell", {
                //	url: "/cross-sell",
                //	component: "productCrossSell",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                .state("main.checkout", {
                url: "/checkout",
                template: "<checkout-wizard></checkout-wizard>",
                data: {
                    meta: {
                        "title": "Checkout"
                    },
                    showFooter: true
                }
            })
                .state("main.checkout.step1", {
                url: "/register",
                template: "<checkout-step1-register></checkout-step1-register>",
                data: {
                    meta: {
                        "title": "Catalog"
                    },
                    showFooter: true
                }
            })
                .state("main.checkout.step2", {
                url: "/address",
                template: "<checkout-step2-address></checkout-step2-address>",
                authenticate: true
            })
                .state("main.checkout.step3", {
                url: "/payment",
                component: "checkoutStep3Payment",
                authenticate: true
            })
                .state("main.checkout.step4", {
                url: "/confirm",
                component: "checkoutStep4Confirm",
                authenticate: true,
                params: {
                    creditCardInfo: null,
                    purchaseOrder: false
                }
            })
                .state("main.checkout.step5", {
                url: "/complete",
                component: "checkoutStep5Complete",
                authenticate: true,
                params: {
                    orderId: null
                }
            })
                .state("main.checkout.payPalExpressCheckoutConfirm", {
                url: "/paypal-ec-confirmation?token&PayerID",
                template: "<paypal-express-checkout-confirmation></paypal-express-checkout-confirmation>",
                authenticate: true
            })
                //typo in URL but keep for existing clients
                .state("main.checkout.monarisCheckoutConfirm", {
                url: "/monaris-hosted-pay-page-confirmation",
                template: "<moneris-hosted-pay-page-confirmation></moneris-hosted-pay-page-confirmation>",
                authenticate: true
            })
                .state("main.checkout.monerisCheckoutConfirm", {
                url: "/moneris-hosted-pay-page-confirmation",
                template: "<moneris-hosted-pay-page-confirmation></moneris-hosted-pay-page-confirmation>",
                authenticate: true
            })
                .state("main.checkout.bamboraCheckoutConfirm", {
                url: "/bambora-payment-form-confirmation",
                template: "<bambora-payment-form-confirmation></bambora-payment-form-confirmation>",
                authenticate: true
            })
                .state("main.checkout.stripeCheckoutSuccess", {
                url: "/stripe-success",
                component: "stripeCheckoutSuccessConfirmation",
                authenticate: true,
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "stripeCheckoutSuccessConfirmation" */
                    "./checkout/payments/stripeCheckoutSuccessConfirmation.component").then(function (mod) { return $ocLazyLoad.load(mod.stripeCheckoutSuccessConfirmation); });
                }
            })
                .state("main.checkout.stripeCheckoutCancel", {
                url: "/stripe-cancel",
                component: "stripeCheckoutCancel",
                authenticate: true,
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "stripeCheckoutCancel" */
                    "./checkout/payments/stripeCheckoutCancel.component").then(function (mod) { return $ocLazyLoad.load(mod.stripeCheckoutCancel); });
                }
            })
                //My Orders
                .state("main.myOrders", {
                url: "/account/orders",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.myOrdersDetails", {
                url: "/account/orders/{orderGuid}",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                //Learning Plan
                .state("main.learningPlan", {
                url: "/account/learning-plan",
                template: "<learning-plan></learning-plan>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learningPath", {
                url: "/account/learning-plan/{number:int}/{version:int}",
                template: "<account-learning-path></account-learning-path>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learningPath.learningItemModal", {
                url: "/{code}",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openComponent("learningItemLearnerAccessModal");
                    }],
                onExit: ["$rootScope", function ($rootScope) {
                        $rootScope.$broadcast("reloadQuickLinks");
                        $rootScope.$broadcast("reloadLearningPath");
                    }],
                params: { requiredForRecognition: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                // Account Learning Item Type Practical Evaluation History
                .state("main.learnerPracticalEvaluationHistory", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/practical-evaluation-history",
                template: "<practical-evaluation-history-learner></practical-evaluation-history-learner>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learnerPracticalEvaluationHistory.filesModal", {
                url: "/{activationNumber}/files",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openStateModal("app/modals/practicalEvaluationHistoryFiles/practicalEvaluationHistoryFilesModalView.html", "PracticalEvaluationHistoryFilesCtrl as vm");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.enrollInSeminar", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/enroll-in-seminar",
                template: "<seminar-learner-access-select-seminar></seminar-learner-access-select-seminar>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learnerSeminarHistory", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/history",
                template: "<seminar-history-learner></seminar-history-learner>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                // Account Learning Item Type External Qualification History
                .state("main.learnerExternalQualificationHistory", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/external-qualification-history",
                template: "<external-qualification-history-learner></external-qualification-history-learner>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learnerExternalQualificationHistory.filesModal", {
                url: "/{activationNumber}/files",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openStateModal("app/modals/externalQualificationHistoryFiles/externalQualificationHistoryFilesModalView.html", "ExternalQualificationHistoryFilesCtrl as vm");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learnerLearningJournalHistory", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/learning-journal-history",
                template: "<learning-journal-history-learner></learning-journal-history-learner>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learnerLearningJournalHistory.filesModal", {
                url: "/{activationNumber}/files",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openStateModal("app/modals/learningJournalHistoryFiles/learningJournalHistoryFilesModalView.html", "LearningJournalHistoryFilesCtrl as vm");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learnerTakeSurvey", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/take-survey",
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                //Webinars learner access
                .state("main.selectWebinar", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/select-a-webinar",
                template: "<webinar-learner-access-select-webinar></webinar-learner-access-select-webinar>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learnerWebinarHistory", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/webinar-history",
                template: "<webinar-history-learner></webinar-history-learner>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.learningPlan.learningItemModal", {
                url: "/{code}",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openComponent("learningItemLearnerAccessModal");
                    }],
                onExit: ["$rootScope", function ($rootScope) {
                        $rootScope.$broadcast("reloadQuickLinks");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                //#region Account Exams
                .state("main.accountExam", {
                url: "/account/exam",
                template: "<exam-validation></exam-validation>",
                params: { assignmentId: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountExamLaunch", {
                url: "/account/exam",
                template: "<launch-exam></launch-exam>",
                params: { examInfo: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountExamQuestion", {
                url: "/account/exam",
                template: "<take-exam-question></take-exam-question>",
                params: { examInfo: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountExamSummary", {
                url: "/account/exam",
                template: "<take-exam-summary></take-exam-summary>",
                params: { examInfo: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountExamResult", {
                url: "/account/exam",
                template: "<take-exam-result></take-exam-result>",
                params: { examInfo: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountExamDetails", {
                url: "/account/exam/details",
                template: "<exam-details></exam-details>",
                params: { examAttemptId: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.accountViewExamDetails", {
                url: "/account/exam/result/{examAttemptId}",
                template: "<exam-details></exam-details>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                //Webinars learner access
                .state("main.selectExamSession", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/select-exam-session",
                template: "<online-exam-leaner-access-select-exam-session></online-exam-leaner-access-select-exam-session>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                },
                params: {
                    assignmentId: null
                }
            })
                //#endregion
                //#region People
                //---------------
                // Accounts
                .state("main.people.accounts", {
                url: "/accounts",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin]
                }
            })
                //.state("main.people.accounts.add", {
                //	url: "/add",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin]
                //	}
                //})
                .state("main.people.accountsBulkAdd", {
                url: "/accounts/bulk-add",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.people.accountsEdit", {
                url: "/accounts/{personSeq}",
                //component: "profile",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.people.viewInventory", {
                url: "/accounts/{personSeq}/inventory",
                //template: "<inventory-summary-list></inventory-summary-list>",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin],
                    isAdmin: true
                }
            })
                .state("main.people.inventoryDetails", {
                url: "/accounts/{personSeq}/inventory/details",
                template: "<inventory-details></inventory-details>",
                params: { data: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin],
                    isAdmin: true
                }
            })
                .state("main.people.viewLearningPlan", {
                url: "/accounts/{personSeq}/learning-plan",
                //template: "<admin-learning-plan></admin-learning-plan>",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.people.viewLearningPath", {
                url: "/accounts/{personSeq}/learning-plan/{number}/{version}",
                template: "<admin-learning-path></admin-learning-path>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                .state("main.people.viewOrders", {
                url: "/accounts/{personSeq}/orders",
                //template: "<accounts-orders></accounts-orders>",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.people.orderDetails", {
                url: "/accounts/{personSeq}/orders/{orderGuid}",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.people.viewDashboard", {
                url: "/dashboard/{personSeq}",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin]
                },
                params: {
                    isReadOnly: true
                }
            })
                // Groups
                .state("main.people.groups", {
                url: "/groups",
                //template: "<manage-groups></manage-groups>",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
                //,
                //lazyLoad: function ($transition$) {
                //	var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //	return import(
                //		/* webpackChunkName: "manageGroups" */
                //		"./groups/manageGroups"
                //	).then(mod => $ocLazyLoad.load(mod.manageGroups));
                //}
            })
                .state("main.people.groupsEdit", {
                url: "/groups/{id}",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.people.groupsBulkImport", {
                url: "/groups/bulk-import",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                // Organizations
                .state("main.people.organizations", {
                url: "/organizations",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.organizationAdmin]
                }
            })
                //.state("main.people.organizations.form", {
                //	onEnter: ["stateModalService", (stateModalService) => {
                //		stateModalService.openStateModal("app/people/organizations/organizationModalFormView.html", "OrganizationModalFormCtrl as vm", "lg");
                //	}],
                //	params: { id: null },
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.organizationAdmin]
                //	}
                //})
                .state("main.people.organizationsBulkAdd", {
                url: "/organizations/bulk-add",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.people.organizationsEdit", {
                url: "/organizations/{id}",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.organizationAdmin]
                }
            })
                // Maintenance
                .state("main.people.maintenance", {
                url: "/people/maintenance",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.organizationAdmin]
                },
                //lazyLoad: function ($transition$) {
                //	var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //	import(
                //		/* webpackChunkName: "mergeAccounts" */
                //		"./people/maintenance/mergeAccounts.component"
                //	).then(mod => $ocLazyLoad.load(mod.mergeAccounts));
                //	return import(
                //		/* webpackChunkName: "organizationMoveAccounts" */
                //		"./people/maintenance/organizationMoveAccounts.component"
                //	).then(mod => $ocLazyLoad.load(mod.organizationMoveAccounts));
                //}
            })
                //#endregion
                //#region Assignments
                //--- Assignments----
                .state("main.assignments.dashboard", {
                url: "/assignments",
                templateUrl: "app/assignments/assignmentsDashboard.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToGroups", {
                url: "/assignments/path-to-groups",
                template: "<paths-to-groups-assignments></paths-to-groups-assignments>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToLearners", {
                url: "/assignments/path-to-learners",
                template: "<paths-to-learners-assignments></paths-to-learners-assignments>",
                params: { orderSeq: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToLearnersOrderSeq", {
                url: "/assignments/path-to-learners/:orderSeq",
                template: "<paths-to-learners-assignments></paths-to-learners-assignments>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
            })
                // Assign Path to group
                .state("main.assignments.pathsToGroupsAdd", {
                url: "/assignments/path-to-groups/add",
                template: "<learning-path-assign></learning-path-assign>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToGroupsAdd.step1", {
                url: "/step1",
                template: "<learning-path-select></learning-path-select>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToGroupsAdd.step2", {
                url: "/step2",
                template: "<group-select></group-select>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToGroupsAdd.step3", {
                url: "/step3",
                templateUrl: "app/assignments/path/steps/assignToPreviewView.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToGroupsAdd.step4", {
                url: "/step4",
                templateUrl: "app/assignments/path/steps/assignToCompletionView.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                // Assign Path to learner
                .state("main.assignments.pathsToLearnersAdd", {
                url: "/assignments/paths-to-learners/add",
                template: "<learning-path-assign></learning-path-assign>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToLearnersAdd.step1", {
                url: "/step1",
                template: "<learning-path-select></learning-path-select>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToLearnersAdd.step2", {
                url: "/step2",
                template: "<learner-select></learner-select>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToLearnersAdd.step3", {
                url: "/step3",
                templateUrl: "app/assignments/path/steps/assignToPreviewView.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.assignments.pathsToLearnersAdd.step4", {
                url: "/step4",
                templateUrl: "app/assignments/path/steps/assignToCompletionView.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                //#endregion
                //#region Learning Items
                //---------------
                //Learning Items
                //---------------
                .state("main.learningItems.manageItems", {
                url: "/learning-items",
                //template: "<learning-item-list></learning-item-list>",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                //Edit
                .state("main.learningItems.manageItemsEdit", {
                url: "/learning-items/:code",
                //template: "<learning-item-edit></learning-item-edit>",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                //Add
                //.state("main.learningItems.add", {
                //	url: "/learning-items/add",
                //	template: "<learning-item-add></learning-item-add>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step1", {
                //	url: "/step1",
                //	templateUrl: "app/learningItems/add/steps/learningItemAddTypeSelectView.html",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step2", {
                //	url: "/step2",
                //	templateUrl: "app/learningItems/add/steps/learningItemAddCommonInfoView.html",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3", {
                //	url: "/step3",
                //	template: "<learning-item-add-specific-info wizard='vm.wizard'></learning-item-add-specific-info>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.Assignment", {
                //	url: "/assignment",
                //	template: "<learning-item-add-assignment wizard='vm.wizard'></learning-item-add-assignment>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.Downloads", {
                //	url: "/downloads",
                //	template: "<learning-item-add-downloads wizard='vm.wizard'></learning-item-add-downloads>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.ExternalQualification", {
                //	url: "/external-qualification",
                //	templateUrl: "app/learningItems/add/steps/learningItemType/learningItemAddExternalQualificationView.html",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.LearningJournal", {
                //	url: "/learning-journal",
                //	template: "<learning-item-add-learning-journal wizard='vm.wizard'></learning-item-add-learning-journal>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.OnlineExam", {
                //	url: "/online-exam",
                //	template: "<learning-item-add-online-exam wizard='vm.wizard'></learning-item-add-online-exam>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.OnlineLesson", {
                //	url: "/online-lesson",
                //	template: "<learning-item-add-online-lesson wizard='vm.wizard'></learning-item-add-online-lesson>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.PracticalEvaluation", {
                //	url: "/practical-evaluation",
                //	template: "<learning-item-add-practical-evaluation wizard='vm.wizard'></learning-item-add-practical-evaluation>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.PracticeExam", {
                //	url: "/practice-exam",
                //	template: "<learning-item-add-online-exam wizard='vm.wizard'></learning-item-add-online-exam>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.Seminar", {
                //	url: "/seminar",
                //	templateUrl: "app/learningItems/add/steps/learningItemType/learningItemAddSeminarView.html",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.Url", {
                //	url: "/url",
                //	template: "<learning-item-add-url wizard='vm.wizard'></learning-item-add-url>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.Webinar", {
                //	url: "/webinar",
                //	template: "<learning-item-add-webinar wizard='vm.wizard'></learning-item-add-webinar>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step3.WorkHistory", {
                //	url: "/work-history",
                //	template: "<learning-item-add-work-history wizard='vm.wizard'></learning-item-add-work-history>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step4", {
                //	url: "/step4",
                //	templateUrl: "app/learningItems/add/steps/learningItemAddPreviewView.html",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step4.preview", {
                //	url: "/preview",
                //	onEnter: ["stateModalService", (stateModalService) => {
                //		stateModalService.openStateModal("app/account/learnerAccess/learningItemLearnerAccessModal.html", "learningItemLearnerAccessModalPreviewCtrl as vm");
                //	}],
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.add.step5", {
                //	url: "/step5",
                //	templateUrl: "app/learningItems/add/steps/learningItemAddCompletionView.html",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.assignment", {
                //	url: "/assignment",
                //	template: "",
                //	//template: "<learning-item-edit-assignment-tab></learning-item-edit-assignment-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.downloadable", {
                //	url: "/downloadable",
                //	template: "",
                //	//template: "<learning-item-edit-downloadable-tab></learning-item-edit-downloadable-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.learningJournal", {
                //	url: "/learning-journal",
                //	template: "",
                //	//template: "<learning-item-edit-learning-journal-tab></learning-item-edit-learning-journal-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.onlineExam", {
                //	url: "/online-exam",
                //	template: "",
                //	//template: "<learning-item-edit-online-exam-tab></learning-item-edit-online-exam-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.onlineLesson", {
                //	url: "/online-lesson",
                //	template: "",
                //	//template: "<learning-item-edit-online-lesson-tab></learning-item-edit-online-lesson-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.practicalEvaluation", {
                //	url: "/practical-evaluation",
                //	template: "",
                //	//template: "<learning-item-edit-practical-evaluation-tab></learning-item-edit-practical-evaluation-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.practiceExam", {
                //	url: "/practice-exam",
                //	template: "",
                //	//template: "<learning-item-edit-online-exam-tab></learning-item-edit-online-exam-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.sbCourse", {
                //	url: "/skillbuilder-course",
                //	template: "",
                //	//template: "<learning-item-edit-sbcourse-tab></learning-item-edit-sbcourse-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.url", {
                //	url: "/url",
                //	template: "",
                //	//template: "<learning-item-edit-url-tab></learning-item-edit-url-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.edit.webinar", {
                //	url: "/webinar",
                //	template: "",
                //	//template: "<learning-item-edit-webinar-tab></learning-item-edit-webinar-tab>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //#endregion Learning Items
                //Categories and Bands
                .state("main.learningItems.manageCategoriesAndBands", {
                url: "/categories",
                template: "<categories-and-bands-manage></categories-and-bands-manage>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.manageSeminars", {
                url: "/seminars",
                template: "<seminar-list></seminar-list>",
                authenticate: true,
                params: {
                    seminarName: null,
                    code: null
                },
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.facilitator, USER_ROLES.groupAdmin]
                }
            })
                .state("main.learningItems.addSeminar", {
                url: "/seminars",
                component: "seminarForm",
                authenticate: true,
                params: {
                    code: null
                },
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.editSeminar", {
                url: "/seminars",
                component: "seminarForm",
                authenticate: true,
                params: { id: null },
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.facilitator, USER_ROLES.groupAdmin]
                }
            })
                //Webinars
                .state("main.learningItems.manageWebinars", {
                url: "/webinars",
                component: "webinarList",
                authenticate: true,
                params: {
                    webinarName: null,
                    code: null
                },
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.facilitator, USER_ROLES.groupAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "webinarList" */
                    "./webinars/webinarList.component").then(function (mod) { return $ocLazyLoad.load(mod.webinarList); });
                }
            })
                .state("main.learningItems.addWebinarSession", {
                url: "/webinars/add",
                component: "webinar",
                authenticate: true,
                params: {
                    code: null
                },
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "webinar" */
                    "./webinars/webinar.component").then(function (mod) { return $ocLazyLoad.load(mod.webinar); });
                }
            })
                .state("main.learningItems.editWebinarSession", {
                url: "/webinars/edit",
                component: "webinar",
                authenticate: true,
                params: { id: null },
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.facilitator, USER_ROLES.groupAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "webinar" */
                    "./webinars/webinar.component").then(function (mod) { return $ocLazyLoad.load(mod.webinar); });
                }
            })
                //#region Learning Paths
                //---------------
                .state("main.learningItems.managePaths", {
                url: "/learning-paths",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                //.state("main.learningItems.addLearningPath", {
                //	url: "/learning-paths/add",
                //	template: "<learning-path-form></learning-path-form>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //Learning Path Versions
                .state("main.learningItems.customCertificates", {
                url: "/learning-paths/custom-certificates",
                template: "<custom-certificates></custom-certificates>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.visibilityWizard", {
                url: "/learning-paths/visibility",
                component: "visibilityWizard",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.visibilityWizard.step1", {
                url: "/step1",
                component: "visibilityWizardStep1",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.learningItems.visibilityWizard.step2", {
                url: "/step2",
                component: "visibilityWizardStep2",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.learningItems.visibilityWizard.step3", {
                url: "/step3",
                templateUrl: "app/learningPaths/visibility/steps/visibilityWizardStep3.component.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.learningItems.visibilityWizard.step4", {
                url: "/step4",
                templateUrl: "app/learningPaths/visibility/steps/visibilityWizardStep4.component.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin, USER_ROLES.groupAdmin]
                }
            })
                .state("main.learningItems.learningPathAndVersion", {
                url: "/learning-paths/{number}/{version}",
                component: "learningPathVersion",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.learningPathVersion", {
                url: "/learning-paths/{number}",
                component: "learningPathVersion",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                },
                params: { version: null }
            })
                .state("main.learningItems.learningPathVersionOpenBadges", {
                url: "/learning-paths/{number}/{version}/open-badges",
                template: "<learning-path-version-open-badges></learning-path-version-open-badges>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.learningPathVersionVisibility", {
                url: "/learning-paths/{number}/{version}/visibility",
                component: "learningPathVersionVisibility",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.learningPathVersionStorefront", {
                url: "/learning-paths/{number}/{version}/storefront",
                template: "<configure-storefront></configure-storefront>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                //.state("main.learningItems.learningPathVersionStorefront.pricing", {
                //	url: "/pricing",
                //	template: "<learning-path-version-storefront-pricing></learning-path-version-storefront-pricing>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.learningPathVersionStorefront.information", {
                //	url: "/info",
                //	template: "<learning-path-version-storefront-detail></learning-path-version-storefront-detail>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //.state("main.learningItems.learningPathVersionStorefront.crossSell", {
                //	url: "/cross-sell",
                //	template: "<learning-path-version-storefront-cross-sell></learning-path-version-storefront-cross-sell>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //#endregion
                //#region Manage Exams
                //---------------
                .state("main.learningItems.manageExams", {
                url: "/exams",
                template: "<manage-exams></manage-exams>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.manageExams.add", {
                url: "/add",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openStateModal("app/exams/addExamModalView.html", "AddExamModalCtrl as vm");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.editExam", {
                url: "/exams/{number}",
                component: "editExam",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.examPrintJobs", {
                url: "/exams/{number}",
                component: "examPrintJobs",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "examPrintJobs" */
                    "./exams/examPrintJobs.component").then(function (mod) { return $ocLazyLoad.load(mod.examPrintJobs); });
                }
            })
                .state("main.learningItems.examPrintJobs.add", {
                url: "/add",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openComponent("addExamPrintJobModal");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "addExamPrintJobModal" */
                    "./exams/addExamPrintJobModal.component").then(function (mod) { return $ocLazyLoad.load(mod.addExamPrintJobModal); });
                }
            })
                .state("main.learningItems.examPrintJob", {
                url: "/exams/{number}",
                component: "examPrintJob",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                },
                params: { id: null },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "examPrintJob" */
                    "./exams/examPrintJob.component").then(function (mod) { return $ocLazyLoad.load(mod.examPrintJob); });
                }
            })
                .state("main.learningItems.manageExamCategories", {
                url: "/exams/{number}/categories",
                template: "<manage-categories></manage-categories>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.manageExamCategories.add", {
                url: "/add",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openStateModal("app/exams/addCategoryModalView.html", "AddCategoryModalCtrl as vm");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.editExamCategory", {
                url: "/exams/{number}/categories/{categoryNumber:int}",
                template: "<edit-exam-category></edit-exam-category>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.manageExamQuestions", {
                url: "/exams/{number}/questions",
                template: "<manage-questions></manage-questions>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.manageExamForms", {
                url: "/exams/{number}/forms",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.addExamQuestion", {
                url: "/exams/{number}/questions/add",
                template: "<exam-question></exam-question>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.editExamQuestion", {
                url: "/exams/{number}/questions/{questionNumber}",
                template: "<exam-question></exam-question>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.importExamQuestions", {
                url: "/exams/{number}/questions/import",
                component: "",
                //authenticate: true,
                params: { examName: null },
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "importExamQuestions" */
                    "./exams/importExamQuestions").then(function (mod) { return $ocLazyLoad.load(mod.importExamQuestions); });
                }
            })
                .state("main.learningItems.manageExamCategoryQuestions", {
                url: "/exams/{number}/categories/{categoryNumber}/questions",
                template: "<manage-questions></manage-questions>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.addExamCategoryQuestion", {
                url: "/exams/{number}/categories/{categoryNumber}/questions/add",
                template: "<exam-question></exam-question>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.learningItems.editExamCategoryQuestion", {
                url: "/exams/{number}/categories/{categoryNumber}/questions/{questionNumber}",
                template: "<exam-question></exam-question>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                //#endregion
                //#region Evaluations
                //Evaluations
                //---------------
                //External Qualifications (Type of Assignment)
                .state("main.evaluations.externalQualifications", {
                url: "/external-qualifications",
                template: "<manage-external-qualifications></manage-external-qualifications>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.externalQualificationHistory", {
                url: "/external-qualifications/{code}/{person}/{assignmentId}/history",
                template: "<external-qualification-history></external-qualification-history>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.externalQualificationHistory.filesModal", {
                url: "/{activationNumber}/files",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openStateModal("app/modals/externalQualificationHistoryFiles/externalQualificationHistoryFilesModalView.html", "ExternalQualificationHistoryFilesCtrl as vm");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.externalQualificationsAdd", {
                url: "/external-qualifications/{code}/{person}/{assignmentId}/history/add",
                template: "<external-qualification-form></external-qualification-form>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.externalQualificationsResume", {
                url: "/external-qualifications/{code}/{person}/{assignmentId}/history/resume",
                template: "<external-qualification-form></external-qualification-form>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.externalQualificationsEdit", {
                url: "/external-qualifications/{code}/{person}/{assignmentId}/history/{activationNumber}",
                template: "<external-qualification-form></external-qualification-form>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                //Assignments Evaluations (Type of Assignment)
                .state("main.evaluations.assignments", {
                url: "/evaluations/score-assignments",
                //template: "<score-assignment-list></score-assignment-list>",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.performanceEvaluator]
                }
            })
                .state("main.evaluations.assignmentsScoreAssignment", {
                url: "/evaluations/score-assignments/{attemptId}",
                //template: "<score-assignment></score-assignment>",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.performanceEvaluator]
                }
            })
                .state("main.learnerAssignmentHistory", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/assignment-history",
                template: "<assignment-history-learner></assignment-history-learner>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                //Work History
                .state("main.evaluations.workHistory", {
                url: "/score-work-history",
                template: "<score-work-history-list></score-work-history-list>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.workHistoryEvaluator, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.scoreWorkHistory", {
                url: "/score-work-history",
                template: "<score-work-history></score-work-history>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.workHistoryEvaluator, USER_ROLES.evaluator]
                },
                params: {
                    attemptId: null
                }
            })
                .state("main.learnerWorkHistoryHistory", {
                url: "/account/learning-plan/{number:int}/{version:int}/{code}/work-history-history",
                template: "<work-history-history-learner></work-history-history-learner>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.all]
                }
            })
                //Practical Evaluations (Type of Assignment)
                .state("main.evaluations.practicalEvaluations", {
                url: "/practical-evaluations",
                template: "<manage-practical-evaluations></manage-practical-evaluations>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.practicalEvaluator]
                }
            })
                .state("main.evaluations.practicalEvaluationHistory", {
                url: "/practical-evaluations/{code}/{person}/{assignmentId}/history",
                template: "<practical-evaluation-history></practical-evaluation-history>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.practicalEvaluator]
                }
            })
                .state("main.evaluations.practicalEvaluationHistory.filesModal", {
                url: "/{activationNumber}/files",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openStateModal("app/modals/practicalEvaluationHistoryFiles/practicalEvaluationHistoryFilesModalView.html", "PracticalEvaluationHistoryFilesCtrl as vm");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.practicalEvaluator]
                }
            })
                .state("main.evaluations.practicalEvaluationsAdd", {
                url: "/practical-evaluations/{code}/{person}/{assignmentId}/history/add",
                template: "<practical-evaluation-form></practical-evaluation-form>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.practicalEvaluator]
                }
            })
                .state("main.evaluations.practicalEvaluationsResume", {
                url: "/practical-evaluations/{code}/{person}/{assignmentId}/history/resume",
                template: "<practical-evaluation-form></practical-evaluation-form>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.practicalEvaluator]
                }
            })
                .state("main.evaluations.practicalEvaluationsEdit", {
                url: "/practical-evaluations/{code}/{person}/{assignmentId}/history/{activationNumber}",
                template: "<practical-evaluation-form></practical-evaluation-form>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.practicalEvaluator]
                }
            })
                .state("main.evaluations.examAttempts", {
                url: "/evaluations/exam-attempt-results",
                component: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                },
                //lazyLoad: function ($transition$) {
                //	var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //	return import(
                //		/* webpackChunkName: "activationExamAttempts" */
                //		"./evaluations/examAttemptResults/activationExamAttempts.component"
                //	).then(mod => $ocLazyLoad.load(mod.ACTIVATION_EXAM_ATTEMPTS));
                //}
            })
                //Online Exams (Type of Assignment)
                .state("main.evaluations.onlineExam", {
                url: "/online-exams",
                template: "<manage-online-exams></manage-online-exams>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.examSessions", {
                url: "/evaluations/exam-sessions",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.examProctor, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.evaluations.examSessionsAdd", {
                url: "/evaluations/exam-sessions/add",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.examProctor, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.evaluations.examSessionsEdit", {
                url: "/evaluations/exam-sessions/{id}",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator, USER_ROLES.examProctor, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.evaluations.onlineExamsHistory", {
                url: "/online-exams/{code}/{person}/{assignmentId}/history",
                template: "<online-exam-history></online-exam-history>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.onlineExamAttemptsHistory", {
                url: "/online-exams/{code}/{person}/{assignmentId}/history/{activationNumber}",
                template: "<online-exam-activations-history></online-exam-activations-history>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.examAttemptsDetails", {
                url: "/evaluations/exam-attempt-results/{examAttemptId}",
                template: "<exam-details></exam-details>",
                params: {
                    person: null
                },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                //Score Online Exams
                .state("main.evaluations.scoreOnlineExamList", {
                url: "/score-online-exams",
                template: "<score-exam-list></score-exam-list>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.evaluator]
                }
            })
                .state("main.evaluations.scoreOnlineExam", {
                url: "/score-online-exams",
                template: "<score-exam></score-exam>",
                params: { attemptId: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.evaluator]
                }
            })
                //#endregion
                //#region Data Export
                .state("main.dataExport.dashboard", {
                url: "/data-export",
                params: { filter: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.reporter]
                }
                //,
                //lazyLoad: function ($transition$) {
                //	var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //	return import(
                //		/* webpackChunkName: "dataExportDashboard" */
                //		"./export/dataExportDashboard.component"
                //	).then(mod => $ocLazyLoad.load(mod.dataExportDashboard));
                //}
            })
                //#endregion
                //#region Reporting
                //Reporting
                //---------------------------------------------
                .state("main.reporting.dashboard", {
                url: "/reports",
                template: "<div></div>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.reporting.adhoc", {
                url: "/reports/adhoc",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.reporter]
                }
            })
                .state("main.reporting.surveys", {
                url: "/reports/survey",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.reporter]
                }
            })
                .state("main.reporting.logicApp", {
                url: "/reports/logic-app",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.reporter]
                }
            })
                .state("main.reporting.learningPathCompletion", {
                url: "/reports/learning-path-completion",
                component: "learningPathCompletionReport",
                params: { filter: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "learningPathCompletionReport" */
                    "./reports/learningPathCompletionReport.component").then(function (mod) { return $ocLazyLoad.load(mod.learningPathCompletionReport); });
                }
            })
                .state("main.reporting.pathCompletion", {
                url: "/reports/path-completion",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin],
                    hideAdminMenu: true
                }
            })
                .state("main.reporting.learningItemCompletion", {
                url: "/reports/learning-item-completion",
                component: "learningItemCompletionReport",
                params: { filter: null },
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "learningItemCompletionReport" */
                    "./reports/learningItemCompletionReport.component").then(function (mod) { return $ocLazyLoad.load(mod.learningItemCompletionReport); });
                }
            })
                .state("main.reporting.itemCompletion", {
                url: "/reports/item-completion",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin],
                    hideAdminMenu: true
                }
            })
                .state("main.reporting.impersonation", {
                url: "/reports/impersonation",
                //component: "impersonationReport",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                } //,
                //	lazyLoad: function ($transition$) {
                //		var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //		return import(
                //			/* webpackChunkName: "impersonationReport" */
                //			"./reports/impersonationReport.component"
                //		).then(mod => $ocLazyLoad.load(mod.impersonationReport));
                //	}
            })
                .state("main.reporting.orderDetails", {
                url: "/reports/order-details",
                template: "<order-details-report></order-details-report>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.reporting.orderSummary", {
                url: "/reports/order-summary",
                template: "<order-summary-report></order-summary-report>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                }
            })
                .state("main.reporting.testItemDetailsList", {
                url: "/reports/test-item-details",
                template: "<test-item-details-report-list></test-item-details-report-list>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.reporting.testItemDetails", {
                url: "/reports/test-item-details/{number}",
                template: "<test-item-details-report></test-item-details-report>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                //.state("main.reporting.myReports", {
                //	url: "/reports/saved",
                //	template: "<my-reports></my-reports>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                //	}
                //})
                //.state("main.reporting.sharedReports", {
                //	url: "/reports/shared",
                //	template: "<shared-reports></<shared-reports>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                //	}
                //})
                //.state("main.reporting.scheduledReports", {
                //	url: "/reports/scheduled",
                //	template: "<scheduled-reports></scheduled-reports>",
                //	params: { report: null },
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                //	}
                //})
                //.state("main.reporting.addScheduledReport", {
                //	url: "/reports/scheduled/add",
                //	template: "<scheduled-report-form></scheduled-report-form>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                //	}
                //})
                //.state("main.reporting.editScheduledReport", {
                //	url: "/reports/scheduled/edit",
                //	template: "<scheduled-report-form></scheduled-report-form",
                //	params: { report: null },
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.groupAdmin, USER_ROLES.reporter, USER_ROLES.organizationAdmin]
                //	}
                //})
                //#endregion
                //#region Storefront
                .state("main.storefront.discounts", {
                url: "/discounts",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.storefront.addDiscount", {
                url: "/discounts/add",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.storefront.editDiscount", {
                url: "/discounts/:id",
                template: "",
                //params: { id: null },
                //authenticate: true,
                data: { authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin] }
            })
                .state("main.storefront.orders", {
                url: "/orders",
                //component: "orderList",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.storefront.orderDetails", {
                url: "/orders/{orderGuid}",
                //component: "orderDetails",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.storefront.viewOrder", {
                url: "/orders/view-order/{id}",
                //component: "viewOrderDetails"
                template: ""
            })
                .state("main.storefront.orderRefund", {
                url: "/orders/{orderGuid}/refund",
                //url: "/orders/{orderGuid}",
                //template: "<order-refund></order-refund>",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.storefront.taxes", {
                url: "/taxes",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                //.state("main.storefront.taxes.addCountryModal", {
                //	url: "/add",
                //	onEnter: ["stateModalService", (stateModalService) => {
                //		stateModalService.openStateModal("app/storefront/taxAddCountryView.html", "TaxAddCountryCtrl as vm");
                //	}],
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin]
                //	}
                //})
                .state("main.storefront.taxFormCountryAndRegions", {
                url: "/taxes/{code}",
                template: "",
                params: { code: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.storefront.taxFormNone", {
                url: "/taxes/{code}/external",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                //#endregion
                //#region Catalog
                .state("main.catalog.carousel", {
                url: "/catalog-carousel",
                component: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "catalogCarousel" */
                    "./catalog/catalogCarousel.component").then(function (mod) { return $ocLazyLoad.load(mod.catalogCarousel); });
                }
            })
                .state("main.catalog.carousel.addBanner", {
                url: "/add",
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openComponent("addCatalogBannerModal");
                    }],
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "addCatalogBannerModal" */
                    "./catalog/addCatalogBannerModal.component").then(function (mod) { return $ocLazyLoad.load(mod.addCatalogBannerModal); });
                }
            })
                .state("main.catalog.carouselEdit", {
                url: "/catalog-carousel/:id",
                component: "catalogCarouselEdit",
                //template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                },
                lazyLoad: function ($transition$) {
                    var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                    return import(
                    /* webpackChunkName: "catalogCarouselEdit" */
                    "./catalog/catalogCarouselEdit.component").then(function (mod) { return $ocLazyLoad.load(mod.catalogCarouselEdit); });
                }
            })
                .state("main.catalog.categories", {
                url: "/catalog-categories",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.catalog.categories.edit", {
                url: "/:slug",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.advancedHomePageConfig", {
                url: "/catalog-homepage",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                //#endregion
                //#region Gamification
                .state("main.gamification.pointSystem", {
                url: "/gamification/point-system",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.gamification.tierSystem", {
                url: "/gamification/tier-system",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.gamification.leaderboardSystem", {
                url: "/gamification/leaderboard-system",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                //#endregion Gamification
                //#region Settings
                //Settings
                //---------------------------------------------
                //.state("main.angularSettings", {
                //	url: "/settings",
                //	template: "",
                //	//authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin],
                //		hideAdminMenu: true
                //	}
                //})
                //.state("main.angularSettingsOther", {
                //	url: "/settings/:views",
                //	template: "",
                //	//authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin],
                //		hideAdminMenu: true
                //	}
                //})
                .state("main.settings.gettingStarted", {
                url: "/admin/getting-started",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.apiToolkit", {
                url: "/admin/api-toolkit",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.systemSettings", {
                url: "/settings",
                //template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.general.panels", {
                url: "/general",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                },
                //views: {
                //	"searchEngine": {
                //		template: "<settings-general-search-engine></settings-general-search-engine>"
                //	},
                //	"contactPreferences": {
                //		template: "<contact-preferences></contact-preferences>"
                //	},
                //	"location": {
                //		template: "<settings-location></settings-location>"
                //	},
                //	"timeZone": {
                //		template: "<settings-time-zone></settings-time-zone>"
                //	},
                //	"secondaryLanguages": {
                //		template: "<secondary-languages></secondary-languages>"
                //	},
                //	"translations": {
                //		templateUrl: "app/settings/general/languages/translations/translationsView.html"
                //	}
                //}
            })
                .state("main.settings.theme", {
                template: "",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.theme.panels", {
                url: "/configuration",
                template: "",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                //Settings -> Subscription
                .state("main.settings.subscription", {
                url: "/subscription",
                template: "<subscription></subscription>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.subscription.currentSubscription", {
                template: "<current-subscription></current-subscription>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.subscription.billingHistory", {
                template: "<billing-history></billing-history>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.subscriptionInvoiceDetails", {
                url: "/subscription/invoice-details/{invoiceId}",
                template: "<invoice-details></invoice-details>",
                authenticate: true,
                params: {
                    fromState: null
                },
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.subscriptionCheckout", {
                url: "/subscription/checkout",
                template: "<subscription-checkout-wizard></subscription-checkout-wizard>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.subscriptionCheckout.step1", {
                url: "/address",
                template: "<subscription-checkout-step1-address></subscription-checkout-step1-address>"
            })
                .state("main.settings.subscriptionCheckout.step2", {
                url: "/payment?token",
                template: "<subscription-checkout-step2-payment></subscription-checkout-step2-payment>"
            })
                .state("main.settings.subscriptionCheckout.step3", {
                url: "/confirm",
                template: "<subscription-checkout-step3-confirm></subscription-checkout-step3-confirm>"
            })
                .state("main.settings.subscriptionCheckout.step4", {
                url: "/complete",
                template: "<subscription-checkout-step4-complete></subscription-checkout-step4-complete>",
                params: {
                    orderId: null
                }
            })
                .state("main.settings.subscriptionPayPalExpressCheckoutConfirm", {
                url: "/subscription/checkout/paypal-ec-confirmation?token&PayerID",
                template: "<subscription-pay-pal-express-checkout-confirmation></subscription-pay-pal-express-checkout-confirmation>",
                authenticate: true
            })
                //Settings -> Custom Pages
                .state("main.settings.customPages", {
                url: "/settings/pages",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.settings.customPagesAddPage", {
                url: "/settings/pages",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.settings.customPagesEditPage", {
                url: "/settings/pages/:id",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                //Settings -> Connections
                .state("main.settings.connections", {
                url: "/connections",
                template: "<connections-list></connections-list>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.connectionFormBambooHRv1Import", {
                url: "/connections/bambooHRv1Import",
                template: "<bamboohr-v1-import></bamboohr-v1-import>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.connectionFormSkillBuilderBridge", {
                url: "/connections/skillBuilderBridge",
                template: "<skillbuilder-bridge></skillbuilder-bridge>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.connectionFormTaxJarSalesTaxV2", {
                url: "/connections/taxJarSalesTaxV2",
                template: "<tax-jar-sales-tax-v2></tax-jar-sales-tax-v2>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.connectionFormDynamics365V82", {
                url: "/connections/dynamics365V82",
                template: "<dynamics365-v82></dynamics365-v82>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.connectionFormDisqus", {
                url: "/connections/disqus",
                template: "<disqus-v3></disqus-v3>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.dataPrivacy", {
                url: "/data-privacy",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                //Settings -> Languages
                //.state("main.settings.languagesAndTimeZone", {
                //	templateUrl: "app/settings/languagesAndTimeZone/languageAndTimeZoneDashboardView.html",
                //	controller: "LanguageAndTimeZoneDashboardCtrl as vm",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin]
                //	}
                //})
                //.state("main.settings.languagesAndTimeZone.panels", {
                //	url: "/languages-and-time-zone",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin]
                //	},
                //	views: {
                //		"timeZone": {
                //			templateUrl: "app/settings/languagesAndTimeZone/timeZone/timeZoneView.html",
                //			controller: "TimeZoneCtrl as vm"
                //		},
                //		"secondaryLanguages": {
                //			templateUrl: "app/settings/languagesAndTimeZone/languages/secondary/secondaryLanguagesView.html",
                //			controller: "SecondaryLanguagesCtrl as vm"
                //		},
                //		"translations": {
                //			templateUrl: "app/settings/languagesAndTimeZone/languages/translations/translationsView.html"
                //		}
                //	}
                //})
                .state("main.settings.translations", {
                url: "/translations",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.settings.translationsProducts", {
                url: "/translations/products",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.settings.translationsProductsEdit", {
                url: "/translations/products/:slug",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.settings.translationsLearningItems", {
                url: "/translations/learning-items",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                .state("main.settings.translationsLearningItemsEdit", {
                url: "/translations/learning-items/:code",
                template: "<learning-item-manage-translations-edit></learning-item-manage-translations-edit>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                }
            })
                //.state("main.learningItems.manageItemsTranslationsEdit", {
                //	url: "/learning-item-translations/:code",
                //	template: "<learning-item-manage-translations-edit></learning-item-manage-translations-edit>",
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin, USER_ROLES.learningItemAdmin]
                //	}
                //})
                //Settings -> Registration
                .state("main.settings.registration", {
                //templateUrl: "app/settings/registration/registrationDashboardView.html",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.registration.panels", {
                url: "/admin/registration",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                },
                views: {
                    "selfRegistration": {
                        template: "<self-registration-settings></self-registration-settings>"
                    },
                    "externalLoginConfigurations": {
                        template: "<external-login-configurations></external-login-configurations>"
                    },
                    "customRegistrationFields": {
                        template: "<custom-registration-fields></custom-registration-fields>"
                    },
                    "tenantRegistrationQuestions": {
                        template: "<tenant-registration-questions></tenant-registration-questions>"
                    }
                }
            })
                .state("main.settings.user", {
                url: "/user",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                //.state("main.settings.user.panels", {
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin]
                //	},
                //	views: {
                //		"loginPageDefaults": {
                //			template: "<login-page-defaults></login-page-defaults>"
                //		},
                //		"options": {
                //			template: "<user-options></user-options>"
                //		}
                //	}
                //})
                //.state("main.settings.externalLoginConfiguration", {
                //	templateUrl: "app/settings/registration/externalLoginSettings/externalLoginFormView.html",
                //	controller: "ExternalLoginFormCtrl as vm",
                //	params: { id: null },
                //	authenticate: true,
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin]
                //	}
                //})
                .state("main.settings.addExternalLoginConfiguration", {
                url: "/admin/registration/externalLogin/add",
                template: "<add-external-login></add-external-login>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.addExternalLoginConfiguration.step1", {
                url: "",
                templateUrl: "app/settings/registration/externalLoginConfigurations/add/steps/selectProviderView.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.addExternalLoginConfiguration.step2", {
                url: "",
                templateUrl: "app/settings/registration/externalLoginConfigurations/add/steps/configureProviderView.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.addExternalLoginConfiguration.step3", {
                url: "",
                templateUrl: "app/settings/registration/externalLoginConfigurations/add/steps/configureSignUpRulesView.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.addExternalLoginConfiguration.step4", {
                url: "",
                templateUrl: "app/settings/registration/externalLoginConfigurations/add/steps/completeConfigurationView.html",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.editExternalLoginConfiguration", {
                url: "/admin/registration/externalLogin/:caption/:id",
                template: "<edit-external-login-configuration></edit-external-login-configuration>",
                authenticate: true,
                //params: { id: null },
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.continuingEducationCredits", {
                url: "/continuing-education-credits",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                },
                //	lazyLoad: function ($transition$) {
                //		var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //		return import(
                //			/* webpackChunkName: "continuingEducationCredits" */
                //			"./settings/cec/continuingEducationCredits.component"
                //		).then(mod => $ocLazyLoad.load(mod.continuingEducationCredits));
                //	}
            })
                .state("main.settings.storefront", {
                url: "/storefront",
                component: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.catalog", {
                url: "/admin/catalog-settings",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
                //lazyLoad: function ($transition$) {
                //	var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //	return import(
                //		/* webpackChunkName: "catalogSettings" */
                //		"./settings/catalog/catalogSettings.component"
                //	).then(mod => $ocLazyLoad.load(mod.catalogSettings));
                //}
            })
                .state("main.settings.forums", {
                url: "/forum-settings",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.paymentMethodAffiniPayHostedPage", {
                url: "/storefront/paymentMethods/AffiniPayHostedPage",
                template: "",
                params: { id: 4, isConfigured: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.paymentMethodBamboraPaymentForm", {
                url: "/storefront/paymentMethods/BamboraPaymentForm",
                template: "",
                params: { id: 3, isConfigured: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.paymentMethodBamboraCustomCheckout", {
                url: "/storefront/paymentMethods/BamboraCustomCheckout",
                template: "",
                params: { id: 5, isConfigured: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.paymentMethodInvoice", {
                url: "/storefront/paymentMethods/Invoice",
                component: "",
                //params: { id: 7, isConfigured: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                },
                //lazyLoad: function ($transition$) {
                //	var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //	return import(
                //		/* webpackChunkName: "paymentMethodInvoice" */
                //		"./settings/storefront/paymentMethod/paymentMethodInvoice.component"
                //	).then(mod => $ocLazyLoad.load(mod.paymentMethodInvoice));
                //}
            })
                .state("main.settings.paymentMethodMonerisCheckout", {
                url: "/storefront/paymentMethods/MonerisCheckout",
                template: "",
                //params: { id: 2, isConfigured: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.paymentMethodPayPalExpressCheckout", {
                url: "/storefront/paymentMethods/PayPalExpressCheckout",
                //template: "<pay-pal-express-checkout></pay-pal-express-checkout>",
                template: "",
                params: { id: 1, isConfigured: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.paymentMethodPurchaseOrder", {
                url: "/storefront/paymentMethods/PurchaseOrder",
                //component: "paymentMethodPurchaseOrder",
                template: "",
                params: { id: 6, isConfigured: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.paymentMethodStripeCheckout", {
                url: "/storefront/paymentMethods/StripeCheckout",
                //component: "stripeCheckout",
                template: "",
                params: { id: 8, isConfigured: null },
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                },
                //lazyLoad: function ($transition$) {
                //	var $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
                //	return import(
                //		/* webpackChunkName: "stripeCheckout" */
                //		"./settings/storefront/paymentMethod/stripeCheckout.component"
                //	).then(mod => $ocLazyLoad.load(mod.stripeCheckout));
                //}
            })
                .state("main.settings.finalizePayPalExpressCheckout", {
                url: "/storefront/finalize-payment-setup/paypal-express-checkout?request_token&verification_code",
                template: "<finalize-pay-pal-express-checkout></finalize-pay-pal-express-checkout>",
                authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.gamification", {
                url: "/gamification",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                .state("main.settings.openBadges", {
                url: "/open-badges",
                template: "",
                //authenticate: true,
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin]
                }
            })
                //Settings -> Custom Pages
                //.state("main.settings.customPages", {
                //	url: "/custom-pages",
                //	templateUrl: "app/settings/customPages/customPagesDashboardView.html",
                //	data: {
                //		authorizedRoles: [USER_ROLES.superAdmin]
                //	}
                //})
                //Settings -> Notifications
                .state("main.settings.notifications", {
                url: "/notifications",
                template: "",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin],
                    meta: {
                        "title": "Notifications"
                    }
                }
            })
                .state("main.settings.editNotificationTemplate", {
                url: "/notifications/:id",
                template: "",
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            })
                .state("main.settings.notifications.pauseLearnerEmails", {
                onEnter: ["stateModalService", function (stateModalService) {
                        stateModalService.openStateModal("app/settings/notifications/pauseLearnerEmailsModalView.html", "PauseLearnerEmailsModalCtrl as vm");
                    }],
                data: {
                    authorizedRoles: [USER_ROLES.superAdmin, USER_ROLES.siteAdmin]
                }
            });
            //#endregion
            $locationProvider.html5Mode(true);
            $locationProvider.hashPrefix("!");
        }]);
    app.config(["$httpProvider", function ($httpProvider) {
            $httpProvider.interceptors.push("authInterceptorService");
            $httpProvider.interceptors.push("templateCacheBusterService");
        }]);
    //#endregion
    //#region RUN
    /* Run */
    app.run([
        "authService", "frameworkService", "homePageService", "versionService", "statusCodeService", "editableOptions", "tmhDynamicLocale", "$rootScope", "$resource", "$localStorage",
        "$translate", "$uibModalStack", "$location", "$window", "$state", "$http", "$templateCache", "$timeout", "ngMeta", "$transitions", runBlock
    ]);
    function runBlock(authService, frameworkService, homePageService, versionService, statusCodeService, editableOptions, tmhDynamicLocale, $rootScope, $resource, $localStorage, $translate, $uibModalStack, $location, $window, $state, $http, $templateCache, $timeout, ngMeta, $transitions) {
        var stateChangeStartOn;
        ngMeta.init();
        $window.myAppErrorLog = [];
        $state.defaultErrorHandler(function (error) {
            // This is a naive example of how to silence the default error handler.
            $window.myAppErrorLog.push(error);
        });
        //if ($location.$$host.indexOf("skillbuilder-uat.com") !== -1) {
        //	$window.gtag('config', 'G-LNLJ8GZ9PD');
        //	//$window.ga("create", "UA-83767118-4", "auto");
        //}
        //else if ($location.$$host.indexOf("skillbuilder.co") !== -1) {
        //	$window.ga("create", "UA-83767118-6", "auto");
        //}
        $rootScope.localhost = $location.$$host.indexOf("localhost") !== -1;
        $rootScope.showPageLoader = true;
        editableOptions.theme = "bs3"; // bootstrap3 theme. Can be also 'bs2', 'default'
        editableOptions.icon_set = "font-awesome"; // bootstrap3 theme. Can be also 'bs2', 'default'
        editableOptions.blurElem = "ignore";
        authService.fillAuthData();
        //testing ngUpgrade requires templates to be manually added to templateCache
        //$http.get("app/accounts/profile.component.html").then(function (response) {
        //	$templateCache.put("app/accounts/profile.component.html", response.data);
        //});
        //var groups: any = ["saas_public"];
        //if (authService.authentication.isAuth) {
        //	if (authService.authentication.isAdmin)
        //		groups.push("saas_admin");
        //	for (var index in authService.authentication.roles) {
        //		if (authService.authentication.roles.hasOwnProperty(index)) {
        //			groups.push("saas_" + authService.authentication.roles[index].replace(/[\s]/g, "").toLowerCase());
        //		}
        //	}
        //}
        $rootScope.toState = "";
        $rootScope.toParams = "";
        $rootScope.fromState = "";
        $rootScope.fromParams = "";
        var loadFullStory = function () {
            var win = window;
            win["_fs_debug"] = false;
            win["_fs_host"] = "fullstory.com";
            //window["_fs_script"] = "edge.fullstory.com/s/fs.js";
            win["_fs_org"] = "KBDP9";
            win["_fs_namespace"] = "FS";
            // ReSharper disable All
            //let load = (m: any, n: any, e: any, t: any, l: any) => {
            //	if (e in m) { if (m.console && m.console.log) { m.console.log("FullStory namespace conflict. Please set win[\"_fs_namespace\"]."); } return; }
            //	let g: any = m[e] = function (a: any, b: any) { g.q ? g.q.push([a, b]) : g._api(a, b); }; g.q = [];
            //	let o: any = n.createElement(t); o.async = 1; o.src = "https://" + win["_fs_host"] + "/s/fs.js";
            //	let y: any = n.getElementsByTagName(t)[0]; y.parentNode.insertBefore(o, y);
            //	g.identify = function (i: any, v: any) { g(l, { uid: i }); if (v) g(l, v) }; g.setUserVars = function (v: any) { g(l, v) }; // eslint-disable-line
            //	g.shutdown = function () { g("rec", !1) }; g.restart = function () { g("rec", !0) };										// eslint-disable-line
            //	g.consent = function (a: any) { g("consent", !arguments.length || a) };														// eslint-disable-line
            //	g.identifyAccount = function (i: any, v: any) { o = "account"; v = v || {}; v.acctId = i; g(o, v) };						// eslint-disable-line
            //	g.clearUserCookie = function () { };
            //};
            //load(win, document, win["_fs_namespace"], "script", "user");
            // ReSharper disable All
            (function (m, n, e, t, l, o, g, y) {
                if (e in m) {
                    if (m.console && m.console.log) {
                        m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
                    }
                    return;
                }
                g = m[e] = function (a, b, s) { g.q ? g.q.push([a, b, s]) : g._api(a, b, s); };
                g.q = [];
                o = n.createElement(t);
                o.async = 1;
                o.crossOrigin = 'anonymous';
                o.src = 'https://edge.fullstory.com/s/fs.js';
                y = n.getElementsByTagName(t)[0];
                y.parentNode.insertBefore(o, y);
                g.identify = function (i, v, s) { g(l, { uid: i }, s); if (v)
                    g(l, v, s); };
                g.setUserVars = function (v, s) { g(l, v, s); };
                g.event = function (i, v, s) { g('event', { n: i, p: v }, s); };
                g.anonymize = function () { g.identify(!!0); };
                g.shutdown = function () { g("rec", !1); };
                g.restart = function () { g("rec", !0); };
                g.log = function (a, b) { g("log", [a, b]); };
                g.consent = function (a) { g("consent", !arguments.length || a); };
                g.identifyAccount = function (i, v) { o = 'account'; v = v || {}; v.acctId = i; g(o, v); };
                g.clearUserCookie = function () { };
                g.setVars = function (n, p) { g('setVars', [n, p]); };
                g._w = {};
                y = 'XMLHttpRequest';
                g._w[y] = m[y];
                y = 'fetch';
                g._w[y] = m[y];
                if (m[y])
                    m[y] = function () { return g._w[y].apply(this, arguments); };
                g._v = "1.3.0";
            })(window, document, window['_fs_namespace'], 'script', 'user');
            // ReSharper enable All
            $timeout(function () {
                if (window.FS !== undefined)
                    window.FS.identify(authService.authentication.tenantId + ":" + authService.authentication.userPersonSeq, { displayName: authService.authentication.userName, email: authService.authentication.userEmail });
            }, 1000);
        };
        var clearFullStory = function () {
            if (window.FS !== undefined)
                window.FS.clearUserCookie();
        };
        $rootScope.$on("signInComplete", function () {
            var freeTrial = frameworkService.data.tenant && frameworkService.data.tenant.subscriptionTypeId === 1 || false;
            if (freeTrial)
                loadFullStory();
            else
                clearFullStory();
        });
        $rootScope.$on("loadSignedInHomePage", function () {
            homePageService.loadSignedInHomePage();
        });
        $rootScope.$on("userSignedOut", function () {
            clearFullStory();
        });
        $transitions.onStart({}, function (trans) {
            $uibModalStack.dismissAll("stateChange");
            var toState = trans.$to().self;
            var toParams = trans.params("to");
            if (toState.authenticate && !authService.authentication.isAuth) {
                $rootScope.signinRedirect = {
                    toState: toState,
                    toParams: toParams
                };
                return trans.router.stateService.target("main.signIn");
            }
            var hideAdminMenu = false;
            var showFooter = false;
            if (toState.data) {
                var authorizedRoles = toState.data.authorizedRoles;
                if (authorizedRoles && !authService.isAuthorized(authorizedRoles)) {
                    //event.preventDefault();
                    if (authService.authentication.isAuth) {
                        // user is not allowed
                        return trans.router.stateService.target("main.accessDenied");
                    }
                    else {
                        // user is not logged in
                        return trans.router.stateService.target("main.signIn");
                    }
                }
                if (toState.data.urlAuthCheck) {
                    var url = $location.url();
                    if (url.toLowerCase().includes("superadmin") && !authService.isSuperAdmin())
                        return trans.router.stateService.target("main.accessDenied");
                    if (url.toLowerCase().includes("siteadmin") && !authService.isSiteAdmin())
                        return trans.router.stateService.target("main.accessDenied");
                }
                showFooter = toState.data.showFooter === true || (toState.data.showFooter === "not-auth" && !authService.authentication.isAuth) || false;
                hideAdminMenu = toState.data.hideAdminMenu || showFooter;
            }
            if (frameworkService.data.hideAdminMenu !== hideAdminMenu) {
                frameworkService.data.hideAdminMenu = hideAdminMenu;
            }
            frameworkService.data.slideAdmin = true;
            $timeout(function () { $rootScope.$broadcast("hideAdminMenu:updated", hideAdminMenu); }, 200); //still need to call this even when hideAdminMenu does not change. (slideAdmin)
            if (frameworkService.data.showFooter !== showFooter) {
                frameworkService.data.showFooter = showFooter;
                //$rootScope.$broadcast("showFooter:updated");
            }
            if (authService.authentication.isMissingRegistrationData && toState.name !== "main.accountMissingRequiredRegistrationFields" && toState.name.indexOf("public.") === -1) {
                return trans.router.stateService.target("main.accountMissingRequiredRegistrationFields", {
                    stateName: toState.name,
                    stateParameters: toParams
                });
            }
            stateChangeStartOn = (new Date()).getTime();
        });
        $transitions.onSuccess({}, function (trans) {
            var duration = (new Date()).getTime() - stateChangeStartOn;
            var toState = trans.$to().self;
            var toParams = angular.copy(trans.params("to"));
            var fromState = trans.$from().self;
            var fromParams = trans.params("from");
            var name = $location.path();
            if (frameworkService.data.sbGoogleAnalyticsCode) {
                $window.gtag('config', frameworkService.data.sbGoogleAnalyticsCode);
            }
            if (frameworkService.data.googleAnalyticsCode) {
                $window.gtag('event', 'page_view', { 'send_to': frameworkService.data.googleAnalyticsCode });
            }
            //$window.ga("send", "pageview", $location.host() + name);
            //$window.ga("tenantTracker.send", "pageview", name);
            var telemetryInitializer = function (envelope) {
                var tags = envelope.tags;
                if (tags) {
                    if (tags["ai.user.authUserId"]) {
                        tags["ai.user.id"] = tags["ai.user.authUserId"]; // updates anonymous id generated by SDK with authenticated user id
                    }
                    tags["ai.operation.name"] = name; // Ensure 'name' is defined in your context
                }
            };
            // Add the telemetry initializer
            var appInsights = getAppInsights();
            if (appInsights) {
                appInsights.addTelemetryInitializer(telemetryInitializer);
                var pageViewTelemetry = {
                    name: null,
                    uri: null,
                    properties: {
                        duration: duration
                    }
                };
                appInsights.trackPageView(pageViewTelemetry);
            }
            if ($state.params.lang) {
                var localization = _.find(frameworkService.data.tenant.enabledLocalizations, { languageCulture: $state.params.lang });
                if (localization) {
                    $rootScope.lang = $state.params.lang;
                    if ($localStorage.currentLocalizationId !== localization.id) {
                        frameworkService.setLocale(localization.languageCulture, localization.id, localization.name);
                    }
                }
            }
            $rootScope.toState = toState;
            $rootScope.toParams = toParams;
            $rootScope.fromState = fromState;
            $rootScope.fromParams = fromParams;
            if ($location.$$port != 443)
                ngMeta.setTag("canonicalUrl", $location.$$protocol + '://' + $location.$$host + ":" + $location.$$port + $location.$$path);
            else
                ngMeta.setTag("canonicalUrl", $location.$$protocol + '://' + $location.$$host + $location.$$path);
            if ($location.$$port != 443)
                ngMeta.setTag("canonicalUrl", $location.$$protocol + '://' + $location.$$host + ":" + $location.$$port + $location.$$path);
            else
                ngMeta.setTag("canonicalUrl", $location.$$protocol + '://' + $location.$$host + $location.$$path);
            console.info("from: " + fromState.name + " to: " + toState.name);
            //Audit
            delete toParams.lang;
            var newObj = {};
            Object.keys(toParams).forEach(function (key) {
                if (toParams[key] !== null)
                    newObj[key] = toParams[key];
            });
            var params = Object.keys(newObj).length === 0 ? "" : JSON.stringify(newObj);
            $rootScope.$broadcast("saveAudit", { page: $location.$$url, params: params });
        });
        $rootScope.$on("$locationChangeStart", function () {
            statusCodeService.setStatusCode("200");
        });
        $rootScope.$on("$translateChangeSuccess", function () {
            var locale = $translate.proposedLanguage() || $translate.use();
            if (locale) {
                $window.moment.locale(locale.toLowerCase());
                tmhDynamicLocale.set(locale);
            }
        });
        //$rootScope.$on(AUTH_EVENTS.notAuthorized, function () {
        //	$state.go("main.accessDenied");
        //});
        //$rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
        //	$state.go("main.signIn");
        //});
        $rootScope.$on("getNewVersion", function () {
            if (!versionService.isOpen())
                versionService.getNewVersion();
        });
        $rootScope.$on("NOT-FOUND", function () {
            $state.go("main.notFound", {}, { location: false }); //updating so code merges to main
        });
        //var viewContentLoads = 0;
        //var checkReady = function (previousContentLoads) {
        //	var currentContentLoads = Number(viewContentLoads) + 0; // Create a local copy of the number of loads
        //	if (previousContentLoads === currentContentLoads) { // Check if we are in a steady state
        //		$timeout(() => {
        //			$window.prerenderReady = true; // Raise the flag saying we are ready
        //			console.log("** prerenderReady **");
        //			//alert("READY");
        //		}, 100);
        //	} else {
        //		if ($window.prerenderReady || currentContentLoads > 20) return; // Runaway check
        //		$timeout(function () { checkReady(currentContentLoads); }, 100); // Wait 100ms and recheck
        //	}
        //};
        //$transitions.onStart({}, () => {
        //	viewContentLoads = 0;
        //});
        //$transitions.onSuccess({}, () => {
        //	//$window.prerenderReady = true;
        //	checkReady(-1); // Changed the state - ready to listen for end of render
        //});
        //$rootScope.$on('$viewContentLoaded', function () {
        //	viewContentLoads++;
        //	//console.log("viewContentLoads: ", viewContentLoads);
        //});
        $rootScope.$on("prerenderReady", function () {
            $timeout(function () {
                console.log("** prerenderReady **");
                $window.prerenderReady = true;
                //alert("prerender ready");
            }, 100);
        });
        //	angular.element(function () {
        //		$window.prerenderReady = true;
        //		console.log('page loading completed');
        //	});
    }
    //#endregion
    //angular.element(function () {
    //	angular.bootstrap(document, ["skillBuilderSaaS"]);
    //});
})());
